export const RESEND_INVITE_OPEN_MODAL = "RESEND_INVITE_OPEN_MODAL";
export const RESEND_INVITE_CLOSE_MODAL = "RESEND_INVITE_CLOSE_MODAL";

export const RESEND_INVITE_REQUEST = "RESEND_INVITE_REQUEST";
export const RESEND_INVITE_RESULT = "RESEND_INVITE_RESULT";

